export default "__VITE_ASSET__CbuiScNw__"